import { forwardRef, type ReactNode } from 'react';
import { PaymentResultIcon } from './PaymentResultIcon';
import layoutStyles from './PaymentResultLayout.module.css';

export interface PaymentResultLoadingProps {
	tone?: 'success' | 'error';
	spinning?: boolean;
	icon?: ReactNode;
}

export const PaymentResultLoading = forwardRef<HTMLDivElement, PaymentResultLoadingProps>(
	({ tone = 'success', spinning = true, icon }, ref) => {
		return (
			<div className={`${layoutStyles.page} ${layoutStyles[`${tone}Bg`]}`}>
				<PaymentResultIcon ref={ref} tone={tone} spinning={spinning} icon={icon} bare ringed />
			</div>
		);
	}
);

PaymentResultLoading.displayName = 'PaymentResultLoading';
